export const CHECKOUT_CALLBACK_PARAM = "checkout-order-id";
